export interface ContactsListMapperI {
  select: boolean;
  id: string;
  title: boolean;
  contactName: string;
  accountName: string;
  dateCreated: string;
  dateModified: string;
  email: string;
  salesRep: string;
  productionManagerName: string;
  salesManagerName: string;
  leadSource: string;
  csrName: string;
  dateRelated: string;
  department: string;
  commissionGroupName: string;
  city: string;
  state: string;
  accountType: string;
  partnerType: string;
  site: string;
}
